import { render, staticRenderFns } from "./DeterminationPurchaseServiceDocuments.vue?vue&type=template&id=c0315b92&scoped=true"
import script from "./DeterminationPurchaseServiceDocuments.vue?vue&type=script&lang=js"
export * from "./DeterminationPurchaseServiceDocuments.vue?vue&type=script&lang=js"
import style0 from "./DeterminationPurchaseServiceDocuments.vue?vue&type=style&index=0&id=c0315b92&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0315b92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0315b92')) {
      api.createRecord('c0315b92', component.options)
    } else {
      api.reload('c0315b92', component.options)
    }
    module.hot.accept("./DeterminationPurchaseServiceDocuments.vue?vue&type=template&id=c0315b92&scoped=true", function () {
      api.rerender('c0315b92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/components/DeterminationPurchaseServiceDocuments.vue"
export default component.exports